﻿export const getFormattedRights = (rights) =>
  Object.keys(rights).map((right) => ({
    label: rights[right],
    value: rights[right],
  }));

export const getFormattedProductCategories = (formProperty) =>
  formProperty?.values?.map((category) => ({
    label: category.label.fallback,
    value: category.id,
  }));
